import Link from 'next/link'
import React from 'react'
import { SpecialPageType } from '../src/model/fragments'
import { usePageLink } from '../src/hooks/usePageLink'
import SvgShare from './icons/SvgShare'

export interface ShareShoppingListButtonProps {}

export const ShareShoppingListButton: React.FunctionComponent<ShareShoppingListButtonProps> =
	({ children }) => {
		const shoppingListShareLink = usePageLink(
			SpecialPageType.shoppingListShare,
		)!

		return (
			<Link {...shoppingListShareLink}>
				<a className="shareShoppingListButton">
					<span className="shareShoppingListButton-icon">
						<SvgShare />
					</span>
					{children}
				</a>
			</Link>
		)
	}
